import React, { useState, useEffect } from 'react'
import Loader from 'react-loader-spinner'

import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useAlert } from 'react-alert'

import Layout from '../../components/Layout/Admin'
import NewChallenge from '../../components/Challenge/New'

import { FormInput, FormLabel, FormSelect, FormButton } from '../../components/Form/Input'

import { Container, Inputs, Challenges, InputItem, InputGroup, Input, Label } from './styles'

import api from '../../services/api'

function NewChallenges(){
  const alert = useAlert()

  const typeOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'themed', label: 'Themed' },
    { value: 'pro', label: 'Pro' },
  ]
  
  //React States
  const [ loader, setLoader ] = useState(true)
  const [ type, setType ] = useState({ label: "Daily", value: 'daily' })
  const [ currentDate, setCurrentDate ] = useState(getDate())
  const [ currentSeason, setCurrentSeason ] = useState(3)

  const [ placeholders, setPlaceholders ] = useState([{}])
  const [ fields, setFields ] = useState([])
  const [ selectPlaceholders, setSelectPlaceholders ] = useState([{}])

  const [ newChallenge, setNewChallenge ] = useState({ name: '', desc: '', reward: '' })
  const [ challenges, setChallenges ] = useState([])

  //Get date in UTC
  function getDate(){
    const date = new Date()

    let year = date.getUTCFullYear()
    let month = date.getUTCMonth() + 1
    let dt = date.getUTCDate()

    if (dt < 10) { dt = '0' + dt }
    if (month < 10) { month = '0' + month }

    return(year + '-' + month + '-' + dt)
  }

  async function getPlaceholders(){
    const response = await api.get(`/placeholders/${type.value}`)
    const result = response.data
    
    let placeholders = []
    result.map((placeholder, index) => {
      placeholders.push({
        value: index,
        label: placeholder.name
      })
    })

    setPlaceholders(result)
    setSelectPlaceholders(placeholders)
    setLoader(false)
  }

  useEffect(() => {
    getPlaceholders()
  }, [type])

  async function updateNewChallenge(index){
    const newChallenge = {
      name: placeholders[index].name,
      desc: placeholders[index].desc,
      reward: placeholders[index].reward
    }
    const newFields = placeholders[index].fields.map((current) => {
      return({ name: current, value: current })
    })
    
    setFields(newFields)
    setNewChallenge(newChallenge)
  }

  function addNewChallenge(e){
    let currentChallenge = { ...newChallenge }
    console.log(currentChallenge)
    fields.map((field) => {
      currentChallenge.desc = currentChallenge.desc.replace(field.name, field.value)
    })

    let challengeList = [...challenges]
    challengeList.push(currentChallenge)

    setChallenges(challengeList)
  }

  function removeChallenge(index){
    let challengeList = [...challenges]
    challengeList = challengeList.filter((challenge, current) => current !== index)
    console.log(challengeList)

    setChallenges(challengeList)
  }

  function updateCurrentChallenge(field, value){
    let currentChallenge = { ...newChallenge }
    currentChallenge[field] = value
    setNewChallenge(currentChallenge)
  }

  function updateField(index, value){
    let currentFields = [ ...fields ]
    currentFields[index].value = value
    setFields(currentFields)
  }

  function updateChallenge(index, field, value){
    let currentChallenges = [...challenges]
    currentChallenges[index][field] = value
    setChallenges(currentChallenges)
  }

  function confirmSend(){
    confirmAlert({
      title: 'Save this challenge list?',
      message: '',
      buttons: [
        {
          label: 'Yes',
          onClick: () => sendChallenge()
        },
        {
          label: 'No'
        }
      ]
    });
  }

  async function sendChallenge(){
    const newChallengeList = {
      type: type.value,
      season: currentSeason,
      date: currentDate,
      challenges
    }
    try {
      const response = await api.post('/challenges', newChallengeList)
      console.log(response)
      alert.success('Challenges saved!')
    } catch (e){
      console.log(e)
      alert.error('An error has occurred. Try again.')
    }
  }

  function renderFields(){
    return(
      <InputGroup>
        { fields.map((field, index) => (
          <InputItem key={index}>
            <Label width={ 20 }><FormLabel>{ field.name }:</FormLabel></Label>
            <Input width={ 50 }>
              <FormInput width={ '100%' } value={ field.value } onChange={(e) => updateField(index, e.target.value)}/>
            </Input>
          </InputItem>
        ))}
      </InputGroup>
    )
  }

  function renderNewChallenges() {
    return (
      <>
        <Inputs>
          <InputGroup>
            <InputItem>
              <Label width={ 15 }><FormLabel>Date:</FormLabel></Label>
              <Input width={ 50 }>
                <FormInput
                center={ 'true' }
                width={ '100%' } 
                value={ currentDate } 
                onChange={(e) => console.log(e)} 
                placeholder={ 'YYYY-MM-DD' } 
                mask={ '9999-99-99' }/>
              </Input>
            </InputItem>

            <InputItem>
              <Label width={ 15 }><FormLabel>Season:</FormLabel></Label>
              <Input width={ 5 }><FormInput width={ '100%' } value={ currentSeason } onChange={(e) => console.log(e)} center={ 'true' }/></Input>
              
              <Label width={ 15 }><FormLabel>Type:</FormLabel></Label>
              <Input width={ 48 }>
                <FormSelect 
                  isSearchable 
                  defaultValue={type} 
                  options={ typeOptions }
                  onChange={ (e) => setType(e) }/>
                </Input>
            </InputItem>
          </InputGroup>

          <InputGroup>
            <InputItem>
              <Label width={ 30 }><FormLabel>Use Template:</FormLabel></Label>
              <Input width={ 65 }>
                <FormSelect 
                  isSearchable 
                  options={ selectPlaceholders }
                  onChange={ (e) => updateNewChallenge(e.value)}
                />
              </Input>
            </InputItem>
          </InputGroup>

          { fields.length > 0 ? renderFields() : '' }

          <InputGroup>
            <InputItem>
              <Label width={ 15 }><FormLabel>Name:</FormLabel></Label>
              <Input width={ 60 }>
                <FormInput width={ '100%' } value={ newChallenge.name } onChange={(e) => updateCurrentChallenge('name', e.target.value)}/>
              </Input>
            </InputItem>

            <InputItem>
              <Label width={ 15 }><FormLabel>Desc:</FormLabel></Label>
              <Input width={ 70 }>
                <FormInput width={ '100%' } value={ newChallenge.desc } onChange={(e) => updateCurrentChallenge('desc', e.target.value)}/>
              </Input>
            </InputItem>

            <InputItem>
              <Label width={ 45 }><FormLabel></FormLabel></Label>

              <Label width={ 15 }><FormLabel>Reward:</FormLabel></Label>
              <Input width={ 10 }>
                <FormInput width={ '100%' } value={ newChallenge.reward } onChange={(e) => updateCurrentChallenge('reward', e.target.value)} center={ 'true' }/>
              </Input>
            </InputItem>
          </InputGroup>

          <InputGroup>
            <InputItem>
              <FormButton onClick={(e) => addNewChallenge(e)}>Add Challenge</FormButton>
            </InputItem>
            
            <InputItem>
              <FormButton onClick={(e) => confirmSend(e)}>Save Challenges</FormButton>
            </InputItem>
          </InputGroup>
        </Inputs>
        <Challenges>
          { challenges.map((challenge, index) => (
            <NewChallenge
              key={ index }
              challengeName={ challenge.name }
              desc={ challenge.desc }
              reward={ challenge.reward }
              onChange={(e) => updateChallenge(index, e.target.name, e.target.value)}
              delete={ () => removeChallenge(index)}
            />
          ))}
        </Challenges>
      </>
    )
  }

  function renderLoader(){
    return(
      <Loader 
        type="Circles"
        color="#FFF"
        height="100"	
        width="100"
      />   
    )
  }

  return (
    <Layout selected="challenges">
      <Container>
        { loader ? renderLoader() : renderNewChallenges() }
      </Container>
    </Layout>
  )
  
}

export default NewChallenges